// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Index-module__tabs___2NC_6","tab":"Index-module__tab___JmpD6 Fonts-module__h3___1f-Kd","active":"Index-module__active___2rPHn"};